// extracted by mini-css-extract-plugin
export default {"rodape":"styles_rodape__oqgxy"};